import "./index.scss";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import './i18n'
import { Provider } from "react-redux";
import Store from "./ReaduxToolkit/Store";

// Suppress React 18+ deprecation warnings for defaultProps on function components (e.g., from reactstrap)
const originalError = console.error;
console.error = (...args: any[]) => {
  if (
    typeof args[0] === "string" &&
    args[0].includes("Support for defaultProps will be removed")
  ) {
    return;
  }
  originalError(...args);
};

const root = ReactDOM.createRoot(
 document.getElementById("root") as HTMLElement
);

root.render(
 <Provider store={Store}>
    <App />
 </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();